import { COLORS } from '../../common/constants'
import { TagmeLoggedInUserProps } from './interfaces'
import { TagmeLoggedInUserStyle } from './styles'
import userImage from '../../assets/images/user.svg'
import { formatPhoneNumber } from '../../utils/phone.utils'

function TagmeLoggedInUser(props: TagmeLoggedInUserProps) {
	const { loggedUser, logout, colorMain = COLORS.main, colorBorder = COLORS.border } = props

	return (
		<div style={{ borderBottom: `1px solid ${colorBorder}` }}>
			<TagmeLoggedInUserStyle colorMain={colorMain} colorBorder={colorBorder}>
				<div className="media">
					<img src={userImage} alt="Foto de perfil" width="40" height="40" />
					<div className="media-body">
						<strong>{loggedUser?.name}</strong><br />
						{formatPhoneNumber(loggedUser?.phone || "")}<br />
						{loggedUser?.email}
					</div>
					<div style={{ marginLeft: 'auto' }}>
						<button type="button" className="btn btn-outline-danger btn-sm" onClick={logout}>
							Editar
						</button>
					</div>
				</div>
			</TagmeLoggedInUserStyle>
		</div>
	)
}

export default TagmeLoggedInUser